import { Average, Distance, Volume, Currency, Mileage } from './../constants/unitsSystem';
import * as i0 from "@angular/core";
export class ConversionService {
    constructor() { }
    getUnitLabels(isStandard) {
        return isStandard
            ? {
                // Imperial System
                average: Average.MILES_PER_GALON,
                distance: Distance.MILE,
                volume: Volume.GALLON,
                currency: Currency.USD,
                mileage: Mileage.MILEAGE
            }
            : {
                // Metric System
                average: Average.KILOMETRES_PER_LITRE,
                distance: Distance.KILOMETRE,
                volume: Volume.LITRE,
                currency: Currency.CAD,
                mileage: Mileage.KILOMETER
            };
    }
}
ConversionService.ngInjectableDef = i0.defineInjectable({ factory: function ConversionService_Factory() { return new ConversionService(); }, token: ConversionService, providedIn: "root" });
